<template>
  <outside-click-listener class="relative" @clickoutside="isOpened = false">
    <search-form-input
      :label="label"
      :value="valueToDisplay"
      :isOpened="isOpened"
      @openstatechange="handleOpenStateChange"
      :readonly="true"
      class="cursor-pointer text-blue"
    />

    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="absolute top-1/2 -translate-y-1/2 right-4 lg:right-6 pointer-events-none">
    	<path d="M7.25 9.375L12.5 14.625L17.75 9.375" stroke="currentcolor" stroke-width="1.5"/>
    </svg>

    <close-button v-if="value.length" @click="handleClearClick" />

    <div class="search-form-dropdown" :class="{'min-w-[16rem] max-w-screen': multiple}" style="display: none" v-show="isOpened">
      <div
        v-for="group in optionGroups"
        :key="group.id"
        class="grid gap-2 px-4 lg:px-2 2xl:px-4 border-t border-gray"
        :class="{ 'py-4': group.label, 'py-2': !group.label }"
      >
        <div
          v-if="group.label"
          v-text="group.label"
          class="
            block
            text-[.75rem]
            leading-none
            -tracking-[0.04em]
            text-zinc-600
            pl-4
          "
        />
        <choice-option 
          v-for="option in group.options"
          :key="option.value"
          class="custom-choice-option cursor-pointer"
          :class="{
            'bg-stone-50': !multiple && valueIsInSelection(option.value),
            'custom-choice-option--big': multiple,
          }"
          :multiple="multiple"
          :label="option.label"
          :name="name"
          :valueAttr="option.value"
          :value="valueIsInSelection(option.value)"
          @input="checked => handleChange(checked, option.value)"
        />
      </div>
      <div class="px-4 lg:px-2 2xl:px-4 border-t border-gray py-2" v-if="multiple">
        <button 
          class="custom-choice-option text-[500] bg-blue text-white w-full justify-center hover:bg-blue focus:bg-blue"
          type="button"
          @click="isOpened = false"
          v-text="t.apply"
        ></button>
      </div>
    </div>
  </outside-click-listener>
</template>

<script>
import SearchFormInput from './input.vue'
import CloseButton from './close-button.vue'
import OutsideClickListener from '../outside-click-listener.vue'
import ChoiceOption from '../choice-option.vue'

export default {
  components: { SearchFormInput, CloseButton, OutsideClickListener, ChoiceOption },
  name: 'SearchFormChoiceList',
  props: {
    name: String,
    label: String,
    optionGroups: Array,
    multiple: Boolean,
    value: Array,
  },
  data() {
    return {
      isOpened: false,
      t: window.bcimmoTranslations || {},
    }
  },
  computed: {
    valueToDisplay() {
      const string = this.selectedOptions.map((option) => option.label).join(', ')
      if (string.length < 20) {
        return string
      }
      return `${this.value.length} option(s) selected`
    },
    selectedOptions() {
      return this.flattenedOptions.filter(option => this.valueIsInSelection(option.value))
    },
    flattenedOptions() {
      return this.optionGroups.map((group) => group.options).flat()
    },
  },
  methods: {
    valueIsInSelection(value) {
      return this.value.includes(value)
    },
    handleChange(checked, value) {
      if (!this.multiple) {
        this.isOpened = false
        this.$emit('input', [value])
        return
      }

      if (checked) {
        this.$emit('input', [...this.value, value])
      } else {
        const index = this.value.indexOf(value)
        this.$emit('input', [
          ...this.value.slice(0, index),
          ...this.value.slice(index + 1),
        ])
      }
    },
    handleOpenStateChange(isOpened) {
      this.isOpened = isOpened
    },
    handleClearClick() {
      this.$emit('input', [])
    }
  },
}
</script>
